import {
    ListProviderPatientsRequest,
    ProviderPatient
} from "@enter/core";
import {IItemListing} from "./root.store";
import {waitForNoReason} from "./util";
import {generateItemListing} from "./util.generator";


export class PatientGenerator {
    public patients: ProviderPatient[] = [];

    // public async loadPatientListing(
    //     lpgr: ListProviderPatientsRequest,
    // ): Promise<IItemListing<ProviderPatient> | undefined> {
    //     await waitForNoReason(400);
    //     return generateItemListing(lpgr, this.patients);
    // }
}